const LOGO_URL = "https://customer-assets.emergentagent.com/job_spa-pos-system/artifacts/zpy718ez_Logo%20Java%20Spa.png";

export function BrandLogo({ size = "md", showText = true }) {
  const sizes = {
    sm: { box: "h-10 w-10", text: "text-lg", sub: "text-[10px]" },
    md: { box: "h-12 w-12", text: "text-xl", sub: "text-[11px]" },
    lg: { box: "h-24 w-24", text: "text-3xl", sub: "text-xs" },
  }[size] || {};

  return (
    <div className="inline-flex items-center gap-3" data-testid="brand-logo">
      <div
        className={`${sizes.box} rounded-xl overflow-hidden bg-charcoal-900 ring-1 ring-gold/30 shadow-[0_0_24px_-6px_rgba(212,175,55,0.45)] flex items-center justify-center`}
      >
        <img src={LOGO_URL} alt="Java SPA" className="w-full h-full object-cover" />
      </div>
      {showText && (
        <div className="leading-tight">
          <div className={`${sizes.text} font-heading font-semibold tracking-tight`}>
            <span className="text-gold">Java</span>{" "}
            <span className="text-leaf">SPA</span>
          </div>
          <div className={`${sizes.sub} uppercase tracking-[0.25em] text-foreground/50`}>
            Riyadh · Luxury
          </div>
        </div>
      )}
    </div>
  );
}
